import { Sidebar_ as AlexandriaSidebar } from 'monica-alexandria';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Sidebar = styled(AlexandriaSidebar)`
    && h6 {
        font-size: 1rem;
        color: ${p => p.theme.color};
        opacity: .65;
        font-family: "fontBold";
        letter-spacing: 1px;
        ${p => !p.expand && 'display: none;'}
    }
`;

export const Sidebar_ = props => {
    const { t } = useTranslation();
    const toggle = () => {
        if (typeof props.setSidebar === 'function') props.setSidebar(value => !value);
        else props.onSidebar?.();
    };
    return <Sidebar
        id="crm-sidebar"
        panelToggle
        expand={props.sidebar}
        onExpand={toggle}
        collapseLabel={t('Close sidebar')}
        expandLabel={t('Open sidebar')}
    >
        {props.children}
    </Sidebar>;
};
